// extracted by mini-css-extract-plugin
module.exports = {"selectCharacters":"Landing_selectCharacters__3fmaN","footer":"Landing_footer__3OGMv","sweepsTerms":"Landing_sweepsTerms__3Zoz9","prizes":"Landing_prizes__17zmj"};